export default __webpack_public_path__ + "static/media/design.8a88c6f9.svg";